import {
    SET_SORT,
} from '../constants/apiConstants';

const initialState = {
    column: 'hip',
    direction: 'asc',
};

const sortReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SORT:
        return {
            column: action.column,
            direction: action.direction,
            tab: action.tab,
        };
    default:
        return state;
    }
};

export default sortReducer;
